export interface BusinessRule {
  id: number;
  name: string;
  fiscal_year_id: string;
  exception_meeting_type_ids: string[];
  rule_value: Record<string, unknown>;
}
